import { render, staticRenderFns } from "./MilestoneStep4.vue?vue&type=template&id=d823e12c&scoped=true"
import script from "./MilestoneStep4.vue?vue&type=script&lang=js"
export * from "./MilestoneStep4.vue?vue&type=script&lang=js"
import style0 from "./MilestoneStep4.vue?vue&type=style&index=0&id=d823e12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d823e12c",
  null
  
)

export default component.exports